module.exports = __webpack_public_path__ + "img/titlePc28-safeimagekit.352cfce2.png";